<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Cargando ... </span>
</div>
<p-toolbar styleClass="p-mb-4">
    <ng-template pTemplate="left">
        <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-success p-mr-2"
            (click)="returnConfirm()"></button>

    </ng-template>
</p-toolbar>

<div class="card">
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_item}}:</span>
                    <span class="p-text-bold">{{itemId}} - {{item!=null && item.descri!=null?item.descri:""}} -
                        {{item!=null && item.descri!=null?item.sellUM:""}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_collection}}:</span>
                    <span class="p-text-bold">{{albumId}} - {{itemsAlbum!=null &&
                        itemsAlbum.name!=null?itemsAlbum.name:""}}</span>
                </div>


                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span class="p-text-bold p-error">{{lbl_message}}</span>
                </div>



            </p-panel>
        </div>



    </div>

    <p-table #dt [value]="lstItemsTrak" [globalFilterFields]="['name']" [rowHover]="true" dataKey="id"
        styleClass="p-datatable-responsive-demo"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">Contenido del album</h5>
       <!--         <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{lbl_search}}..." />
                </span>
        -->        
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <p-autoComplete placeholder="{{lbl_search}}: {{lbl_entry_item}} ..." [(ngModel)]="selectedItemsTrak"
                        [showEmptyMessage]="true" [suggestions]="filteredItemsTrack" 
                        (completeMethod)="filterItemsTrack($event)" field="name" [minLength]="1"
                        (ngModelChange)="redirectDtl($event)">
                    </p-autoComplete>
                </span>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>

                <th style="width:2rem" pSortableColumn="sequence">
                    {{lbl_id}}<p-sortIcon field="sequence">
                    </p-sortIcon>
                </th>
                <th style="width:16rem" pSortableColumn="name">{{lbl_name}}<p-sortIcon field="name">
                    </p-sortIcon>
                </th>
                <th style="width:5rem" pSortableColumn="duration">
                    {{lbl_duration}}<p-sortIcon field="duration">
                    </p-sortIcon>
                </th>

                <th style="width:9rem"> </th>
                <th style="width:5rem"> {{lbl_play}}</th>
                <th style="width:5rem"> {{lbl_stop}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-value>
            <tr>
                <td>{{value.id.sequence}}</td>
                <td>{{value.name}}</td>
                <td>{{value.duration}}</td>

                <td>
                    <button type="button" pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        (click)="removeSelected(value)"></button>
                    <button pButton pRipple icon="pi pi-angle-double-up" class="p-button-rounded p-button-info p-mr-2"
                        (click)="moveUp(value)" title="move Up"></button>
                    <button pButton pRipple icon="pi pi-angle-double-down" class="p-button-rounded p-button-info p-mr-2"
                        (click)="moveDown(value)" title="Move Down"></button>
                </td>
                <td>
                    <button type="button" pButton pRipple icon="pi pi-play" (click)="onClickPlayFile(value)"
                        *ngIf="value.fileName || value.idToPlay" [disabled]="value.readyToPlay!='READY'"></button>
                </td>
                <td>
                    <button type="button" pButton pRipple icon="pi pi-circle-off" (click)="stopFile()"
                        *ngIf="value.fileName || value.idToPlay" [disabled]="value.readyToPlay!='READY'"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{lbl_total}} {{lstItemsTrak ? lstItemsTrak.length : 0 }} .
            </div>
        </ng-template>
    </p-table>

    <p-dialog [(visible)]="itemDialog" [style]="{width: '750px'}" header="itemTrack" [modal]="true"
        styleClass="p-fluid">
        <ng-template pTemplate="content">

            <div class="p-field">
                <label for="sequence">{{lbl_id}} sequencia: *</label>
                <p-inputNumber id="sequence" [(ngModel)]="sequence" mode="decimal" [max]="999"></p-inputNumber>
                <small class="p-error" *ngIf="!sequence">{{lbl_id}} requerida.</small>
                <label for="name">{{lbl_name}}: *</label>
                <input type="text" pInputText id="name" [(ngModel)]="name" required autofocus maxlength="50" />
                <small class="p-error" *ngIf="!name">{{lbl_name}} requerido.</small>
                <label for="duration">{{lbl_duration}}: *</label>
                <input type="text" pInputText id="duration" [(ngModel)]="duration" required autofocus maxlength="8" />
                <label for="length">{{lbl_length}} (KB):</label>
                <p-inputNumber id="length" [(ngModel)]="length" mode="decimal" [max]="99999"></p-inputNumber>


            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-times" class="p-button-danger p-button-text"
                (click)="hideDialog()"></button>
            <button pButton pRipple label="{{lbl_delete_record}}" icon="pi pi-times"
                class="p-button-delete p-button-text" (click)="removeSelected()"></button>
            <button pButton pRipple label="{{lbl_save}}" icon="pi pi-check" class="p-button-success p-button-text"
                (click)="createUpdateTrack()"></button>
        </ng-template>
    </p-dialog>
    <p-dialog [(visible)]="itemDialogTrack" [style]="{width: '750px'}" header="itemTrack" [modal]="true"
        styleClass="p-fluid">
        <ng-template pTemplate="content">
        </ng-template>
        <ng-template pTemplate="footer">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-times" class="p-button-danger p-button-text"
                (click)="hideDialogTrack()"></button>
        </ng-template>
    </p-dialog>



</div>